import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { EmailHistoryGridObject } from '@libs/types/src/services/object-type/email-history.object';
import { EmailHistorySendInput } from '@libs/types/src/services/input-type/email-history.send-input';

@Injectable({ providedIn: 'root' })
export class EmailHistoryGqlService extends GqlServiceV2 {

    public getServiceEmailHistory(input: GridInput | null, fragment: string) {
        return this.query<EmailHistoryGridObject>(
            `
                query($input: GridInput!) {
                    emailHistory {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public sendEmailWithHistory(input: EmailHistorySendInput | null, fragment: string = 'ok') {
        return this.mutate<EmailHistoryGridObject>(
            `
                mutation($input: EmailHistorySendInput!) {
                    emailHistory {
                        sendWithHistory(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
